export const STEPS = [
  { n: 1, slug: "", label: "Inizia" },
  { n: 2, slug: "chi-siamo", label: "Chi siamo" },
  { n: 3, slug: "referenze", label: "Le referenze" },
  { n: 4, slug: "come-funziona", label: "Il video" },
  { n: 5, slug: "soluzione", label: "La soluzione" },
  { n: 6, slug: "azienda", label: "La vostra struttura", cta: "La vostra struttura" },
  { n: 7, slug: "contatto", label: "Parliamone", cta: "Vai ai recapiti" },
];

export const ATTIVITA = ["Industria alimentare", "Magazzini e logistica", "Ristorazione", "Agricoltura e allevamenti", "Grande distribuzione", "Industria e infrastrutture", "Privato / abitazione", "Altro"];

export const SUPERFICIE = ["Fino a 200 m²", "200–500 m²", "500–1.000 m²", "1.000–5.000 m²", "Oltre 5.000 m²", "Non so"];

export const DOCS = [
  {
    n: 1,
    label: "01 · Marina Militare",
    source: "Marina Militare",
    img: "/assets/testimonianza_08.jpeg",
    quote: "«al momento il problema roditori sembra essere risolto e i sistemi di controllo “dissuasori” funzionano regolarmente.»",
  },
  {
    n: 2,
    label: "02 · TEMAR",
    source: "TEMAR",
    img: "/assets/testimonianza_06.jpeg",
    quote: "«il problema era di difficile soluzione, ma direi che adesso i risultati sono stati apprezzabili.»",
  },
  {
    n: 3,
    label: "03 · Vincenzo",
    source: "Vincenzo",
    img: "/assets/testimonianza_12.jpeg",
    systemTag: "TRANS RAT INDUSTRY",
    quote: "«il riscontro è positivo in quanto non riscontriamo la presenza di topi nelle zone impiantate e stiamo aspettando una vs offerta per un altro impianto in un altro magazzino.»",
  },
  {
    n: 4,
    label: "04 · Cliente Leonardo Soluzioni",
    source: "Cliente Leonardo Soluzioni",
    img: "/assets/testimonianza_04.jpeg",
    quote: "«notiamo un sostanziale miglioramento e ne siamo davvero felici.»",
  },
  {
    n: 5,
    label: "05 · Giuseppe",
    source: "Giuseppe",
    img: "/assets/testimonianza_02.jpeg",
    quote: "«il sistema sembra funzionare. Non ci sono tracce di roditori.»",
  },
  {
    n: 6,
    label: "06 · Filippo",
    source: "Filippo",
    img: "/assets/testimonianza_01.jpeg",
    quote: "«confermo problema risolto, probabilmente a breve mi farò vivo per un altro dispositivo da utilizzare come deterrente per il magazzino.»",
  },
  {
    n: 7,
    label: "07 · Antonio · Servizi Tecnici",
    source: "Antonio · Servizi Tecnici",
    img: "/assets/testimonianza_10.jpeg",
    quote: "«l'impianto sta andando bene, infatti sono a chiederLe l'offerta per la fornitura di due unità distinte da installare nelle nostre due cabine elettriche di trasformazione.»",
  },
  {
    n: 8,
    label: "08 · Antonio · Ufficio Acquisti",
    source: "Antonio · Ufficio Acquisti",
    img: "/assets/testimonianza_13.jpeg",
    quote: "«come riferito dal ns. RSPP Ing., il riscontro per l'area trattata è da ritenersi molto positivo.»",
  },
  {
    n: 9,
    label: "09 · Piero e Raffaella",
    source: "Piero e Raffaella",
    img: "/assets/testimonianza_15.jpeg",
    quote: "«non abbiamo riscontrato alcuna traccia della presenza di roditori all'interno dei nostri laboratori… i tre dispositivi installati funzionano perfettamente in sincronia con la centralina.»",
  },
  {
    n: 10,
    label: "10 · Maddalena e Davide",
    source: "Maddalena e Davide",
    img: "/assets/testimonianza_11.jpeg",
    quote: "«al momento il problema appare risolto in modo efficace.»",
  },
  {
    n: 11,
    label: "11 · Roberto",
    source: "Roberto",
    img: "/assets/testimonianza_03.jpeg",
    quote: "«con l'installazione dei dissuasori ho risolto la questione roditori… è già da diversi mesi che non li metto in funzione perché sembrerebbe non sia più necessario.»",
  },
  {
    n: 12,
    label: "12 · Ninni",
    source: "Ninni",
    img: "/assets/testimonianza_07.jpeg",
    quote: "«il vostro impianto ha portato un ottimo risultato… sono letteralmente spariti, non ci sono più segni di topi. L'impianto è sempre in funzione e non dà problemi.»",
  },
  {
    n: 13,
    label: "13 · Tofé",
    source: "Tofé",
    img: "/assets/testimonianza_09.jpeg",
    quote: "«buonasera, per ora bene grazie.»",
  },
  {
    n: 14,
    label: "14 · Cliente aziendale · Segreteria",
    source: "Cliente aziendale · Segreteria",
    img: "/assets/testimonianza_05.jpeg",
    quote: "«il problema dei roditori è stato risolto, grazie.»",
  },
];

export const REFERENCE_LOGOS = [
  { src: "/assets/references/enel.webp", alt: "ENEL" },
  { src: "/assets/references/eni.webp", alt: "ENI" },
  { src: "/assets/references/terna.webp", alt: "Terna" },
  { src: "/assets/references/rfi.webp", alt: "RFI" },
  { src: "/assets/references/conad.webp", alt: "Conad" },
  { src: "/assets/references/cigierre.webp", alt: "Cigierre" },
];
